import * as React from 'react';

function SvgVCard(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 17" focusable={false} role="presentation" aria-hidden={true} {...props}>
      <path d="M22.8 0H1.2A1.21 1.21 0 000 1.21v14.58A1.21 1.21 0 001.2 17h21.6a1.21 1.21 0 001.2-1.21V1.21A1.21 1.21 0 0022.8 0zm-7.2 4.86h4.8v1.21h-4.8zm-2.4 9.47a3.08 3.08 0 00-.63-.37C11.15 13.35 9 12.43 9 11.32c0-.67.43-.45.62-1.67.08-.51.47 0 .54-1.17C10.17 8 10 7.9 10 7.9s.1-.68.15-1.21-.31-2.18-1.58-2.54c-.22-.23-.37-.14.31-.5C7.39 3.58 7 4.37 6.25 5a2.13 2.13 0 00-.83 1.7c0 .52.15 1.21.15 1.21s-.21.11-.21.57c.07 1.16.46.66.54 1.17.19 1.22.62 1 .62 1.67 0 1.11-2.14 2-3.55 2.64a2.89 2.89 0 00-.57.32V2.43h10.8zm8.4-4.62h-6V8.5h6z" />
    </svg>
  );
}

const MemoSvgVCard = React.memo(SvgVCard);
export default MemoSvgVCard;
